import {
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { Text } from '@main/complykit/components/text';

export type CompactProgressStatCardProps = {
  onClick: () => void;
  progressPercentage: number;
  title: string;
  subTitle?: string;
};

export const CompactProgressStatCard = ({
  onClick,
  progressPercentage,
  title,
  subTitle,
}: CompactProgressStatCardProps) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const hoverBgColor = useColorModeValue('gray.50', 'whiteAlpha.50');
  const textColor = useColorModeValue('gray.900', 'gray.100');
  const progressTrackColor = useColorModeValue('gray.100', 'whiteAlpha.200');

  return (
    <Flex
      role="button"
      tabIndex={0}
      border="1px"
      borderColor={borderColor}
      rounded="md"
      w={{ base: '100%', sm: '260px' }}
      p={4}
      cursor="pointer"
      onClick={onClick}
      align="center"
      justify="space-between"
      _hover={{ bg: hoverBgColor }}
      transition="background-color 0.2s"
    >
      <Stack spacing={0} flex="1" mr={3} overflow="hidden">
        <Text isTruncated weight="medium" size="sm">
          {title}
        </Text>
        <Text isTruncated size="xs" color="muted">
          {subTitle}
        </Text>
      </Stack>
      <CircularProgress
        value={progressPercentage}
        color="green.500"
        trackColor={progressTrackColor}
        size="48px"
        thickness="6px"
      >
        <CircularProgressLabel color={textColor}>
          <Text as="span" size="xs">
            {Math.round(progressPercentage)}%
          </Text>
        </CircularProgressLabel>
      </CircularProgress>
    </Flex>
  );
};
